
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/market-brands",
      function () {
        return require("private-next-pages/market-brands.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/market-brands"])
      });
    }
  